import { TYPES_SIGNIN } from 'components/TargetedOffers/constants';

export const getTargetedOffersQuery = targetedOffersQuery => {
  const [typeEmail, typeLoyalty] = TYPES_SIGNIN;
  const { TypeSignIn, loyaltyID, email } = targetedOffersQuery;
  if (TypeSignIn == typeLoyalty) {
    return { query: { loyaltyID: loyaltyID }, value: loyaltyID };
  }
  if (TypeSignIn == typeEmail) {
    return { query: { email: email }, value: email };
  }
  return {};
};
